import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
// import Modal from 'react-responsive-modal';
import { MdClose } from "react-icons/md";
import { IoClose } from "react-icons/io5";
import { useTaskContext } from "../../../../context/TaskContext";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { CREATE_NEW_KEY_WORD } from "../../../../apollo/Mutations";
import KeywordModal from "./KeywordModal";
// import sortArrayByKey from "../../../../Utils/useSortedArray";


function KeywordSection({ handleKeyword, task, type }) {

  const { keywords, OnUpdateTask, isObserver, } = useTaskContext()
  const { active_task } = useSelector(state => state.task)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [create_keyword] = useMutation(CREATE_NEW_KEY_WORD)
  const [all_keywords_data, setAllKeyWordsData] = useState(keywords);
  // const [newKeyword, setNewKeyword] = useState('');

  useEffect(() => {
    setAllKeyWordsData(keywords);
  }, [keywords])

  const addKeyword = async (value) => {
    const trimmedKeyword = value.trim();

    if (trimmedKeyword !== '') {
      // Check if the keyword already exists (case-insensitive and ignoring spaces)
      const keywordExists = all_keywords_data.some(
        (keyword) => keyword.keywords_title.trim().toLowerCase() === trimmedKeyword.toLowerCase()
      );

      if (keywordExists) {
        toast.error('Keyword already exists');
        return;
      }

      try {
        let apires = await create_keyword({
          variables: {
            input: {
              keywords_title: trimmedKeyword
            }
          }
        });

        if (apires.data.create_new_key_word.status) {
          let { _id, keywords_title } = apires.data.create_new_key_word.data;
          setAllKeyWordsData(prev => [{ _id, keywords_title }, ...prev]);
          toast.success(apires.data.create_new_key_word.message);
        } else {
          toast.success(apires.data.create_new_key_word.message);
        }

      } catch (error) {
        console.log(error);
      }
      // setNewKeyword('');
    }
  };

  const selectKeyword = (keyword) => {
    // setNewKeyword('');
    if (type === 'create') {
      handleKeyword(task.temp_key, 'add', keyword)
    } else {
      OnUpdateTask({ key_words: [...active_task?.key_words, keyword.keywords_title], save_type: 'keyword' })
    }
  };

  const removeKeyword = (keyword) => {
    handleKeyword(task.temp_key, 'remove', keyword);
  }

  

  // const closeIcon = (<MdClose className="text-3xl mt-1 text-teal-600 dark:text-white" />);

  // ---------------- FUNCTIONS ---------------- //

  const visibleKeywords = active_task?.key_words?.slice(0, 2) || [];
  const hiddenKeywordCount = Math.max((active_task?.key_words?.length || 0) - 2, 0);

  return (
    <>
      <div className="flex gap-2 flex-wrap">
        {visibleKeywords.map((keyword, i) => (
          <span key={keyword} className={`flex items-center justify-center text-xs font-medium px-3 py-1 rounded-full bg-teal-200`}>
            {keyword}

            {!isObserver() && <IoClose
              onClick={() => OnUpdateTask({ key_words: [...active_task?.key_words?.filter(f => f !== keyword)], save_type: 'keyword' })}
              className="cursor-pointer text-gray-500 ml-1"
            />}
          </span>
        ))}
        {hiddenKeywordCount > 0 &&
          <button onClick={() => setIsModalOpen(true)} className="text-xs font-medium px-3 py-1 rounded-full bg-white/10 text-white border border-white/20">
            + {hiddenKeywordCount} more
          </button>
        }
        <button onClick={() => setIsModalOpen(true)} className="text-xs font-medium px-3 py-1 rounded-full bg-white/10 text-white border border-white/20">
          + add
        </button>
      </div>
      {/* ---------------- MODAL ---------------- */}
      {/* <Modal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        center
        closeIcon={closeIcon}
        focusTrapped={false}
        classNames={{
          overlay: "customOverlay",
          modal: "customModal",
        }}
      >
        <h2 className="text-xl font-semibold text-teal-600">
          Keywords
        </h2>

        <div className="flex flex-wrap gap-2 mb-3 mt-3">
          {type === 'description' && active_task?.key_words?.length > 0 ?
            <>
              {active_task?.key_words?.map((keyword, index) => (
                <div key={index} className="bg-teal-200 px-2 rounded py-0.5 flex items-center gap-1.5 h-[28px]">
                  <span className="text-teal-600 text-sm">
                    {keyword}
                  </span>
                  {!isObserver() && <IoClose
                    onClick={() => OnUpdateTask({ key_words: [...active_task?.key_words?.filter(f => f !== keyword)], save_type: 'keyword' })}
                    className="cursor-pointer text-gray-700"
                  />}
                </div>
              ))}
            </> 
            :
            <>
              {task?.key_words?.map((keyword, index) => (
                <div
                  key={index}
                  className="bg-teal-200 px-2 rounded py-0.5 flex items-center gap-1.5 h-[28px]"
                >
                  <span className="text-teal-600 text-sm">
                    {keyword}
                  </span>
                  {!isObserver() && <IoClose onClick={() => removeKeyword(keyword)} className="cursor-pointer text-gray-700" />}
                </div>
              ))}
            </>
          }
        </div>


        <div className="relative">
          <input
            className="w-full border px-3 py-2 rounded text-sm text-teal-600"
            placeholder="Search or create keyword"
            value={newKeyword}
            onChange={(e) => setNewKeyword(e.target.value)}
          />
          {newKeyword !== '' &&
            <MdClose className="absolute right-3 top-5 -translate-y-1/2 text-gray-500 cursor-pointer" onClick={() => setNewKeyword('')} />
          }
        </div>

        <div className="h-[180px] overflow-auto mt-3">
          {filter_keywords.length > 0 ? (
            sortArrayByKey(filter_keywords, 'keywords_title', 'asc').map((keyword) => (
              <p
                key={keyword._id}
                onClick={() => selectKeyword(keyword)}
                className="px-2 py-1.5 text-sm text-teal-700 cursor-pointer hover:bg-gray-100 rounded"
              >
                {keyword.keywords_title}
              </p>
            ))
          ) : (
            <div className="flex justify-center items-center h-full">
              {newKeyword.trim() !== '' && !keywords.some(k => k.keywords_title.toLowerCase() === newKeyword.trim().toLowerCase()) ? (
                <button
                  onClick={addKeyword}
                  className="bg-teal-600 text-white px-3 py-1.5 rounded-full text-sm"
                >
                  Create "{newKeyword}"
                </button>
              ) : (
                <p className="text-sm text-gray-600">
                  No keywords found
                </p>
              )}
            </div>
          )}
        </div>
      </Modal> */}

      <KeywordModal
        type={type}
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        keywords={all_keywords_data}
        selectKeyword={selectKeyword}
        task={task}
        onAdd={addKeyword}
        onRemove={removeKeyword}
      />
    </>
  );
}

export default KeywordSection;
